// extracted by mini-css-extract-plugin
export default {"ContentContainer-fullscreen":"ContentContainer-fullscreen2SG-CePZxh8W"};